// extracted by mini-css-extract-plugin
export default {"commonWrapper":"GroupBySelector_commonWrapper__2qBQG","wrapper":"GroupBySelector_wrapper__cSwa3"};